import { render, staticRenderFns } from "./order-review.vue?vue&type=template&id=0d4399c6&scoped=true"
import script from "./order-review.vue?vue&type=script&lang=ts"
export * from "./order-review.vue?vue&type=script&lang=ts"
import style0 from "./order-review.vue?vue&type=style&index=0&id=0d4399c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4399c6",
  null
  
)

export default component.exports